(() => {
  if (window.PurefectSidePickerLoaded) return;
  window.PurefectSidePickerLoaded = true;

  const getPickersForForm = (formId) =>
    Array.from(document.querySelectorAll('purefect-side-picker')).filter(
      (picker) => picker.dataset.formId === formId
    );

  const getPickerGroup = (formId) =>
    Array.from(document.querySelectorAll('[data-pm-side-pickers]')).find(
      (group) => group.dataset.formId === formId
    );

  const getProductForm = (formId) => document.getElementById(formId)?.closest('product-form');

  const getNativeSubmitButton = (formId) => {
    const productForm = getProductForm(formId);
    return (
      productForm?.querySelector('button[name="add"]:not(.po-atc-btn)') ||
      productForm?.querySelector('button[name="add"]') ||
      null
    );
  };

  const setButtonText = (button, text) => {
    const label = button?.querySelector(':scope > span');
    if (label) label.textContent = text;
  };

  const syncFormGate = (formId) => {
    if (!formId) return;

    const pickers = getPickersForForm(formId);
    const group = getPickerGroup(formId);
    const button = getNativeSubmitButton(formId);
    if (!pickers.length || !group) return;

    const selectedCount = pickers.filter((picker) => picker.checkedInput).length;
    const requiredCount = pickers.length;
    const remainingCount = requiredCount - selectedCount;
    const status = group.querySelector('[data-pm-side-status]');

    group.dataset.pmComplete = remainingCount === 0 ? 'true' : 'false';

    if (status) {
      if (remainingCount === 0) {
        status.textContent = `${selectedCount} of ${requiredCount} selected. ${button?.dataset.pmFavoriteReadyText || 'Ready to add.'}`;
      } else if (requiredCount === 1) {
        status.textContent = '0 of 1 selected. Choose your side to continue.';
      } else if (remainingCount === 1) {
        status.textContent = '1 of 2 selected. Choose one more side to continue.';
      } else {
        status.textContent = '0 of 2 selected. Choose both sides to continue.';
      }
    }

    if (!button || button.classList.contains('loading')) return;

    if (!button.dataset.pmSideStatusBound && status?.id) {
      const currentDescription = button.getAttribute('aria-describedby') || '';
      button.dataset.pmPreviousDescribedby = currentDescription;
      button.setAttribute('aria-describedby', `${currentDescription} ${status.id}`.trim());
      button.dataset.pmSideStatusBound = 'true';
    }

    const buttonLabel = button.querySelector(':scope > span')?.textContent.trim() || '';
    const unavailableLabels = [window.variantStrings?.soldOut, window.variantStrings?.unavailable].filter(Boolean);
    const nativeUnavailable =
      button.dataset.pmNativeDisabled === 'true' ||
      unavailableLabels.includes(buttonLabel) ||
      (button.disabled && button.dataset.pmSideGated !== 'true');

    if (nativeUnavailable) {
      button.dataset.pmNativeDisabled = 'true';
      button.setAttribute('aria-disabled', 'true');
      delete button.dataset.pmSideGated;
      return;
    }

    if (!button.dataset.pmDefaultText) {
      button.dataset.pmDefaultText =
        buttonLabel ||
        window.variantStrings?.addToCart ||
        'Add to cart';
    }

    if (remainingCount > 0) {
      button.dataset.pmSideGated = 'true';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      setButtonText(
        button,
        requiredCount === 1
          ? 'Choose your side first'
          : remainingCount === 1
            ? 'Choose 1 more side'
            : `Choose ${remainingCount} sides first`
      );
      return;
    }

    if (remainingCount === 0 && button.dataset.pmSideGated === 'true') {
      delete button.dataset.pmSideGated;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      setButtonText(button, button.dataset.pmDefaultText || window.variantStrings?.addToCart || 'Add to cart');
    }
  };

  const bindDialog = (dialog) => {
    if (!dialog || dialog.dataset.pmBound === 'true') return;
    dialog.dataset.pmBound = 'true';

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
      if (event.target.closest('[data-pm-dialog-primary]')) {
        dialog.pmReturnFocus = dialog.pmPrimaryTarget || dialog.pmReturnFocus;
      }
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      const quickAddDrawer = dialog.closest('quick-add-modal');
      if (quickAddDrawer) {
        quickAddDrawer.dataset.pmNestedEscape = 'true';
        window.setTimeout(() => delete quickAddDrawer.dataset.pmNestedEscape, 350);
      }
      dialog.close();
    });

    dialog.addEventListener('close', () => {
      const target = dialog.pmReturnFocus;
      dialog.pmReturnFocus = null;
      dialog.pmPrimaryTarget = null;
      if (!target?.isConnected) return;

      const details = target.closest('details');
      if (details && target.matches('summary')) details.open = true;
      window.setTimeout(() => target.focus({ preventScroll: false }), 0);
    });
  };

  const showCartIssue = ({ formId, title, message, actionLabel, returnFocus, primaryTarget }) => {
    const dialog = getPickerGroup(formId)?.querySelector('[data-pm-cart-issue-dialog]');
    if (!dialog) return false;

    bindDialog(dialog);
    dialog.querySelector('[data-pm-dialog-title]').textContent = title;
    dialog.querySelector('[data-pm-dialog-message]').textContent = message;
    dialog.querySelector('[data-pm-dialog-primary]').textContent = actionLabel;
    dialog.pmReturnFocus = returnFocus || document.activeElement;
    dialog.pmPrimaryTarget = primaryTarget || returnFocus || document.activeElement;

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    window.setTimeout(() => dialog.querySelector('[data-pm-dialog-primary]')?.focus(), 0);
    return true;
  };

  const showMissingSelections = (formId, invalidPickers, totalPickerCount) => {
    const firstInvalid = invalidPickers[0];
    const names = invalidPickers.map((picker) => picker.dataset.propertyName);
    const bothMissing = totalPickerCount === 2 && invalidPickers.length === 2;
    const onlyName = names[0] || 'Side One';
    const favoriteMessage = getNativeSubmitButton(formId)?.dataset.pmFavoriteMissingSide;

    if (bothMissing) {
      return showCartIssue({
        formId,
        title: 'Choose both included sides',
        message:
          'Select an actual side for Side One and Side Two. Those field labels are not selections.',
        actionLabel: 'Choose sides',
        returnFocus: document.activeElement,
        primaryTarget: firstInvalid?.summary,
      });
    }

    return showCartIssue({
      formId,
      title: `${onlyName} is still required`,
      message: favoriteMessage || `Select an actual side for ${onlyName} before adding this meal to your cart.`,
      actionLabel: `Choose ${onlyName}`,
      returnFocus: document.activeElement,
      primaryTarget: firstInvalid?.summary,
    });
  };

  class PurefectSidePicker extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.error = this.querySelector('[role="alert"]');
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      this.querySelectorAll('img').forEach((image) => {
        image.addEventListener('error', () => image.setAttribute('hidden', ''), { signal, once: true });
      });
      this.updateSelection();
      window.setTimeout(() => syncFormGate(this.dataset.formId), 0);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get checkedInput() {
      return this.querySelector('input[type="radio"][data-pm-real-side="true"]:checked');
    }

    onChange(event) {
      if (!event.target.matches('input[type="radio"]')) return;
      this.updateSelection();
      this.clearInvalid();
      syncFormGate(this.dataset.formId);
    }

    onClick(event) {
      const radio = event.target.closest('label')?.querySelector('input[type="radio"]');
      if (!radio) return;
      window.setTimeout(() => {
        this.details.open = false;
        this.summary.focus({ preventScroll: true });
      }, 0);
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || !this.details.open) return;
      event.preventDefault();
      event.stopPropagation();
      const quickAddDrawer = this.closest('quick-add-modal');
      if (quickAddDrawer) {
        quickAddDrawer.dataset.pmNestedEscape = 'true';
        window.setTimeout(() => delete quickAddDrawer.dataset.pmNestedEscape, 350);
      }
      this.details.open = false;
      this.summary.focus({ preventScroll: true });
    }

    updateSelection() {
      const input = this.checkedInput;
      if (!input) return;
      const option = input.closest('label');
      const optionImage = option?.querySelector('img');
      const selectedImage = this.querySelector('[data-selected-image]');
      const selectedLabel = this.querySelector('[data-selected-label]');
      const selectedThumb = this.querySelector('[data-selected-thumb]');
      const selectionState = this.querySelector('[data-selection-state]');

      this.classList.add('has-selection');
      if (selectionState) selectionState.textContent = 'Selected';
      if (selectedLabel) selectedLabel.textContent = input.value;
      if (optionImage && selectedImage) {
        selectedImage.src = optionImage.currentSrc || optionImage.src;
        selectedImage.hidden = false;
        selectedThumb?.classList.add('has-image');
      }
    }

    showInvalid() {
      this.classList.add('is-invalid');
      this.summary?.setAttribute('aria-invalid', 'true');
      if (this.error) this.error.hidden = false;
      if (this.details) this.details.open = true;
    }

    clearInvalid() {
      this.classList.remove('is-invalid');
      this.summary?.removeAttribute('aria-invalid');
      if (this.error) this.error.hidden = true;
    }
  }

  if (!customElements.get('purefect-side-picker')) {
    customElements.define('purefect-side-picker', PurefectSidePicker);
  }

  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('purefect-side-picker details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('form[data-type="add-to-cart-form"]');
      const formId = form?.getAttribute('id');
      if (!formId) return;

      const pickers = getPickersForForm(formId);
      if (!pickers.length) return;

      const invalidPickers = pickers.filter((picker) => !picker.checkedInput);
      pickers.filter((picker) => picker.checkedInput).forEach((picker) => picker.clearInvalid());

      if (!invalidPickers.length) {
        syncFormGate(formId);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      invalidPickers.forEach((picker) => picker.showInvalid());
      syncFormGate(formId);

      const dialogOpened = showMissingSelections(formId, invalidPickers, pickers.length);
      if (!dialogOpened) invalidPickers[0].summary?.focus();
    },
    true
  );

  document.addEventListener('purefect:cart-error', (event) => {
    const formId = event.detail?.formId;
    if (!formId || !getPickersForForm(formId).length) return;

    const button = getNativeSubmitButton(formId);
    showCartIssue({
      formId,
      title: 'We couldn\u2019t add this meal',
      message:
        event.detail?.message ||
        'Something interrupted the request. Check your connection and try again.',
      actionLabel: 'Try again',
      returnFocus: button,
      primaryTarget: button,
    });
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-pm-side-pickers]').forEach((group) => syncFormGate(group.dataset.formId));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.setTimeout(() => {
        document.querySelectorAll('[data-pm-side-pickers]').forEach((group) => syncFormGate(group.dataset.formId));
      }, 0);
    });
  }
})();

